// Named export kept for existing callers (`import { handleRequestErrors }`).
// eslint-disable-next-line import/prefer-default-export
export const handleRequestErrors = async (response, displayToast = true) => {
  const jsonResponse = await response.json();

  if (response.ok) {
    if (displayToast) showtoast(jsonResponse.message);
  } else {
    if (displayToast) {
      const message = jsonResponse.message || jsonResponse.errors;
      showtoast(message);
    }
    throw Error(response.statusText);
  }

  return jsonResponse;
};
